var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"default-layout",style:(_vm.accessToken == null ? 'margin-left: 0px;' : '')},[_c('Sidebar'),_c('div',{staticClass:"content-panel",style:(_vm.accessToken == null ? 'max-width: 100%;' : '')},[_c('Topbar'),_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }